import React from 'react';
import { TailSpin } from 'react-loader-spinner';

interface ConsoleOutputProps {
  output: string;
  isExecuting: boolean;
}

const ConsoleOutput: React.FC<ConsoleOutputProps> = ({ output, isExecuting }) => {
  return (
    <div id="consoleOutput" className="consoleOutput">
      <div className="console-content">
        {output}
      </div>
      {isExecuting && (
        <div className="spinner-overlay-console">
          <TailSpin
            height="50"
            width="50"
            color="#00BFFF"
            ariaLabel="executing"
          />
        </div>
      )}
    </div>
  );
};

export default ConsoleOutput;